import '../kickstart';

import { h, render } from 'preact';

import App from '../locator';
import initCountdown from '../countdown';

// county: Object { name: "Hardin", fips: 48199 }
// sboe: Object { district: 7 }
// tx_house: Object { district: 19 }
// tx_senate: Object { district: 3 }
// us_house: Object { district: 36 }

render(<App />, document.getElementById('app'));
initCountdown();
